module.exports = __webpack_public_path__ + "assets/img/KeyReport_cover.b9c3882b-ps.jpg";